import gql from 'graphql-tag'

export const productPriceUnsubscribeMutation = gql`
mutation productPriceUnsubscribe($id: ID!) {
    productPriceUnsubscribe(product_id: $id)
}
`
